import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import * as styles from "./richtext.module.css"
import Slider from "react-slick"

const HotelCarouselSection = ({ blok }) => {

  const settings = {
    autoplay: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  const hotelImage = (image) => (
    <div {...storyblokEditable(image)} key={image.id}>
      { image.filename &&
        <img className={`w-full h-[440px] ${blok.keepImageRatio ? 'object-contain' : 'object-cover'}`} loading="lazy" src={image.filename} alt={image.alt} />
      }
    </div>
  )
  
  return (
    <section {...storyblokEditable(blok)} className="hotel-carousel-section container max-w-screen-xl mx-auto py-10 overflow-x-hidden">
      <div className="flex flex-wrap">
        <div className={`w-full md:w-1/2 ${blok.carouselPosition === 'Right'? 'order-2': 'order-1'} px-3`}>
          <div className="slider-container">
            <Slider {...settings}>{blok.hotelImages.map(image => (hotelImage(image)))}</Slider>
          </div>
        </div>
        <div className={`w-full md:w-1/2 ${blok.carouselPosition === 'Right'? 'order-1': 'order-2'}`}>
          <div className="p-8">
            <h3 className="text-3xl font-bold font-serif">{blok.heading}</h3>
            <div className={`${styles.richText}`} dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
          </div>
        </div>
      </div>
    </section>
  )
};

export default HotelCarouselSection;
